import React from "react";

const Intro = ({ title, subtitle, body }) => {
    return (
        <>
            <h2 className="introtext">{title}</h2>
            <h3 className="introtext">{subtitle}</h3>
            <h4 className="introtext">{body}</h4>
        </>
    );
};

export default Intro;
